const deadlocket = {
    id: "deadlocket",
    title: "DEADLOCKET",
    left: "DEADLOCKET",
    right: "Windows companion",
    image: "/images/deadlocket/cover.png",
    parallax1: 0,
    parallax2: 0,
    link: "/projects/deadlocket",
    website: "https://deadlocket.com/",
    description: "A desktop companion for Deadlock, from finding your next hero and build to understanding how your last match played out.",
};

export default deadlocket;
